module.exports = __webpack_public_path__ + "media/images/solutions-forms-triplet-2-1f11e6d40de0a9eab8cdb275e5bb4e17.svg";